export const identity = (d) => d;
//# sourceMappingURL=identity.js.map